export const ServiceStyle = {
    mainBox: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        height: "100%",
        p: 2,
    },
    dealerLogo: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
    },
    tableBox: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        px: 1,
    },
   listBox: {
    display: "flex",
    flexDirection: "column",
    gap: window.innerWidth <= 750 ? "2px" : "10px",
    width: "100%",
    justifyContent: "space-between",
    px: window.innerWidth <= 750 ? 1 : "10%",
},
    listMainBox: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        gap: window.innerWidth <= 750 ? "15px" : null,
    },
    informationBox: {
        display: "flex",
        flexDirection: "row",
        gap: "8px",
        justifyContent: "start",
        alignItems: "center",
        width: window.innerWidth > 600 ? "160px" : "140px",
        flexShrink: 0,
    },
    launchIconBox: {
        display: "flex",
        flexDirection: "row",
        gap: "15px",
        justifyContent: "center",
        alignItems: "center",
        width: window.innerWidth <= 750 ? "60%" : "50%",
    },
    poppuMainBox: {
        // width: "100%",
        // height: "100%",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    toggleBox: {
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 3,
        // width: "100%",
        p: 2,
        // backgroundColor: "#fff",
    },
    videoBox: {
        // width: { xs: "100%", sm: "400px" },
        // position: "relative",
        // // width: "100%",
        // // height: "100%",
        // // aspectRatio: window.innerWidth <= 750 ? "9/20" : null,
        // overflow: "hidden",
        zIndex: 0,
    },
    loadingBox: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2,
        bgcolor: "#fff",
    },
    videoStyle: {
        width: "100%",
        height: "100%",
        maxHeight: "100%",
        objectFit: "contain",
        objectPosition: "center top",
        transition: "opacity 0.4s ease-in-out",
    },
    textBox: {
        position: "relative",
        width: "100%",
        height: "100%",
        paddingTop: "70px",
    },
    insideText: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "start",
        p: 3,
        gap: 1,
    }
}